/* A file picked on one page, opened on another.
 *
 * Attaching a PDF on Home used to open the New Project chooser ON HOME — you picked a file
 * from the hero and got a modal over the marketing page, with your projects nowhere in sight.
 * The flow belongs on the Workspace, so Home now navigates there. The file has to survive that
 * navigation, and it cannot travel in the URL: a File is not a string.
 *
 * Module state rather than router state on purpose. `navigate(..., { state })` puts the value
 * in history.entry.state, which the browser serialises — a File survives a structured clone
 * but NOT a reload, so it would come back as an empty object on refresh and the modal would
 * open holding nothing while believing it held a file. In memory the answer is unambiguous:
 * after a reload there is no pending upload, and `take()` says so.
 *
 * `take()` and not `get()` — it is a one-shot handoff. Leaving it behind would re-open the
 * uploader with a stale file the next time anyone landed on /workspace?mode=upload.
 */
let pending = null;

/** Stash files for the next page to collect. */
export const setPendingUpload = (files) => {
  pending = files && files.length ? Array.from(files) : null;
};

/** Collect and clear. Returns null when there is nothing waiting (e.g. after a reload). */
export const takePendingUpload = () => {
  const files = pending;
  pending = null;
  return files;
};
